import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css``,
  productItem: css``,
  productItemImage: css`
    width: 120px !important;
    height: 120px !important;
    padding: 8px;
  `,
}));

export const useSharedProductsShortListStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
